var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#354d9e;stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.5 -2.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 6.611,
    height: 6.611,
    transform: "translate(3 3)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 6.611,
    height: 6.611,
    transform: "translate(13.389 3)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 6.611,
    height: 6.611,
    transform: "translate(13.389 13.389)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 6.611,
    height: 6.611,
    transform: "translate(3 13.389)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.814d4c2123403e8911896179c1985285.svg";
export { ForwardRef as ReactComponent };